export const ANOS = [
  "6 EF",
  "7 EF",
  "8 EF",
  "9 EF",
  "1 EM",
  "2 EM",
  "3 EM",
  "Pre-vest.",
  "Cursinho",
  "Outro",
];

// Critérios fixos legados: usados só como fallback para calcular desafios
// antigos, criados antes dos critérios passarem a vir das Atividades
// (tela de Pontuação). tipo_ids eram IDs fixos que já não correspondem
// necessariamente às atividades reais cadastradas hoje.
export const CRITERIOS_DESAFIO_LEGADO = [
  {
    id: "questões",
    label: "Mais questões feitas",
    tipo_ids: [2, 5],
    unidade: "questao",
  },
  {
    id: "horas",
    label: "Mais horas de estudo",
    tipo_ids: [1, 4],
    unidade: "hora",
  },
  {
    id: "videoaula",
    label: "Mais horas de videoaula",
    tipo_ids: [1],
    unidade: "hora",
  },
  {
    id: "resumos",
    label: "Mais resumos feitos",
    tipo_ids: [3],
    unidade: "unidade",
  },
  {
    id: "indicacoes",
    label: "Mais indicacoes trazidas",
    tipo_ids: [6, 7],
    unidade: "pessoa",
  },
];
export const CRITERIO_PONTOS = {
  id: "pontos",
  label: "Mais pontos de ranking",
  unidade: "ponto",
};

// Monta os critérios de vitória a partir das atividades cadastradas na tela
// de Pontuação, para o desafio sempre refletir a pontuação configurada pelo
// admin (em vez de uma lista fixa de critérios desatualizada).
export function getCriteriosDesafio(activities = []) {
  const porAtividade = (activities || [])
    .filter((item) => item.ativo)
    .sort(
      (left, right) =>
        (left.ordem ?? 0) - (right.ordem ?? 0) || left.id - right.id,
    )
    .map((item) => ({
      id: String(item.id),
      label: `Mais ${item.nome}`,
      unidade: item.unidade,
    }));
  return [CRITERIO_PONTOS, ...porAtividade];
}
export const PERIODOS_HORARIOS = [
  {
    id: "tarde",
    label: "Tarde (14:00 – 18:00)",
  },
  {
    id: "noite",
    label: "Noite (18:00 – 22:00)",
  },
];
export const MERITOS_DEF = [
  {
    id: "h10",
    cat: "horas",
    titulo: "Estudante",
    desc: "10 horas totais de estudo",
    icone: "*",
    meta: 10,
    tipo: "horas_total",
    img: null,
    cor: "#3B82F6",
  },
  {
    id: "h50",
    cat: "horas",
    titulo: "Dedicado",
    desc: "50 horas totais de estudo",
    icone: "*",
    meta: 50,
    tipo: "horas_total",
  },
  {
    id: "h100",
    cat: "horas",
    titulo: "Centuriao",
    desc: "100 horas totais de estudo",
    icone: "*",
    meta: 100,
    tipo: "horas_total",
  },
  {
    id: "h250",
    cat: "horas",
    titulo: "Maratonista",
    desc: "250 horas totais de estudo",
    icone: "*",
    meta: 250,
    tipo: "horas_total",
  },
  {
    id: "h500",
    cat: "horas",
    titulo: "Mestre do Tempo",
    desc: "500 horas totais de estudo",
    icone: "*",
    meta: 500,
    tipo: "horas_total",
  },
  {
    id: "h1000",
    cat: "horas",
    titulo: "Lendario",
    desc: "1000 horas totais de estudo",
    icone: "*",
    meta: 1000,
    tipo: "horas_total",
  },
  {
    id: "h2000",
    cat: "horas",
    titulo: "Immortal",
    desc: "2000 horas totais de estudo",
    icone: "*",
    meta: 2000,
    tipo: "horas_total",
  },
  {
    id: "hs5",
    cat: "horas",
    titulo: "Semana Produtiva",
    desc: "5 horas numa semana",
    icone: "*",
    meta: 5,
    tipo: "horas_semana",
  },
  {
    id: "hs15",
    cat: "horas",
    titulo: "Semana Intensa",
    desc: "15 horas numa semana",
    icone: "*",
    meta: 15,
    tipo: "horas_semana",
  },
  {
    id: "hs30",
    cat: "horas",
    titulo: "Semana Lendaria",
    desc: "30 horas numa semana",
    icone: "*",
    meta: 30,
    tipo: "horas_semana",
  },
  {
    id: "hs50",
    cat: "horas",
    titulo: "Semana Insana",
    desc: "50 horas numa semana",
    icone: "*",
    meta: 50,
    tipo: "horas_semana",
  },
  {
    id: "q100",
    cat: "questões",
    titulo: "Iniciante",
    desc: "100 questões resolvidas",
    icone: "*",
    meta: 100,
    tipo: "questões_total",
  },
  {
    id: "q500",
    cat: "questões",
    titulo: "Questionador",
    desc: "500 questões resolvidas",
    icone: "*",
    meta: 500,
    tipo: "questões_total",
  },
  {
    id: "q1000",
    cat: "questões",
    titulo: "Mil Questões",
    desc: "1000 questões resolvidas",
    icone: "*",
    meta: 1000,
    tipo: "questões_total",
  },
  {
    id: "q5000",
    cat: "questões",
    titulo: "Dez Mil Questões",
    desc: "5000 questões resolvidas",
    icone: "*",
    meta: 5000,
    tipo: "questões_total",
  },
  {
    id: "q10k",
    cat: "questões",
    titulo: "Maquina",
    desc: "10000 questões resolvidas",
    icone: "*",
    meta: 10000,
    tipo: "questões_total",
  },
  {
    id: "qs50",
    cat: "questões",
    titulo: "Bateu Meta",
    desc: "50 questões em 1 semana",
    icone: "*",
    meta: 50,
    tipo: "questões_semana",
  },
  {
    id: "qs200",
    cat: "questões",
    titulo: "Semana Intensa",
    desc: "200 questões em 1 semana",
    icone: "*",
    meta: 200,
    tipo: "questões_semana",
  },
  {
    id: "qs500",
    cat: "questões",
    titulo: "Monstro",
    desc: "500 questões em 1 semana",
    icone: "*",
    meta: 500,
    tipo: "questões_semana",
  },
  {
    id: "r10",
    cat: "resumos",
    titulo: "Resumidor",
    desc: "10 resumos feitos",
    icone: "*",
    meta: 10,
    tipo: "resumos_total",
  },
  {
    id: "r50",
    cat: "resumos",
    titulo: "Organizador",
    desc: "50 resumos feitos",
    icone: "*",
    meta: 50,
    tipo: "resumos_total",
  },
  {
    id: "r100",
    cat: "resumos",
    titulo: "Mestre Resumo",
    desc: "100 resumos feitos",
    icone: "*",
    meta: 100,
    tipo: "resumos_total",
  },
  {
    id: "c3",
    cat: "streak",
    titulo: "3 Dias Seguidos",
    desc: "Checkpoint 3 dias consecutivos",
    icone: "*",
    meta: 3,
    tipo: "streak",
  },
  {
    id: "c7",
    cat: "streak",
    titulo: "1 Semana Seguida",
    desc: "Checkpoint 7 dias consecutivos",
    icone: "*",
    meta: 7,
    tipo: "streak",
  },
  {
    id: "c14",
    cat: "streak",
    titulo: "2 Semanas!",
    desc: "Checkpoint 14 dias consecutivos",
    icone: "*",
    meta: 14,
    tipo: "streak",
  },
  {
    id: "c30",
    cat: "streak",
    titulo: "1 Mes Seguido",
    desc: "Checkpoint 30 dias consecutivos",
    icone: "*",
    meta: 30,
    tipo: "streak",
  },
  {
    id: "cp5",
    cat: "streak",
    titulo: "5 Checkpoints",
    desc: "5 checkpoints registrados",
    icone: "*",
    meta: 5,
    tipo: "checkpoints_total",
  },
  {
    id: "cp20",
    cat: "streak",
    titulo: "20 Checkpoints",
    desc: "20 checkpoints registrados",
    icone: "*",
    meta: 20,
    tipo: "checkpoints_total",
  },
  {
    id: "cp50",
    cat: "streak",
    titulo: "50 Checkpoints",
    desc: "50 checkpoints registrados",
    icone: "*",
    meta: 50,
    tipo: "checkpoints_total",
  },
  {
    id: "cp100",
    cat: "streak",
    titulo: "100 Checkpoints",
    desc: "100 checkpoints registrados",
    icone: "*",
    meta: 100,
    tipo: "checkpoints_total",
  },
  {
    id: "p100",
    cat: "pontos",
    titulo: "Primeiros Pontos",
    desc: "100 pontos de ranking acumulados",
    icone: "*",
    meta: 100,
    tipo: "pontos_total",
  },
  {
    id: "p500",
    cat: "pontos",
    titulo: "Meio Mil",
    desc: "500 pontos de ranking acumulados",
    icone: "*",
    meta: 500,
    tipo: "pontos_total",
  },
  {
    id: "p1000",
    cat: "pontos",
    titulo: "Mil Pontos",
    desc: "1000 pontos de ranking acumulados",
    icone: "*",
    meta: 1000,
    tipo: "pontos_total",
  },
  {
    id: "p5000",
    cat: "pontos",
    titulo: "Cinco Mil",
    desc: "5000 pontos de ranking acumulados",
    icone: "*",
    meta: 5000,
    tipo: "pontos_total",
  },
  {
    id: "p10k",
    cat: "pontos",
    titulo: "Dez Mil",
    desc: "10000 pontos de ranking acumulados",
    icone: "*",
    meta: 10000,
    tipo: "pontos_total",
  },
  {
    id: "i1",
    cat: "social",
    titulo: "Recrutador",
    desc: "1 indicação bem-sucedida",
    icone: "*",
    meta: 1,
    tipo: "indicacoes_total",
  },
  {
    id: "i5",
    cat: "social",
    titulo: "Embaixador",
    desc: "5 indicacoes bem-sucedidas",
    icone: "*",
    meta: 5,
    tipo: "indicacoes_total",
  },
  {
    id: "i10",
    cat: "social",
    titulo: "Influencer",
    desc: "10 indicacoes bem-sucedidas",
    icone: "*",
    meta: 10,
    tipo: "indicacoes_total",
  },
  {
    id: "d1",
    cat: "desafios",
    titulo: "Primeiro Duelo",
    desc: "Vencer 1 desafio",
    icone: "*",
    meta: 1,
    tipo: "desafios_vencidos",
  },
  {
    id: "d5",
    cat: "desafios",
    titulo: "Guerreiro",
    desc: "Vencer 5 desafios",
    icone: "*",
    meta: 5,
    tipo: "desafios_vencidos",
  },
  {
    id: "d10",
    cat: "desafios",
    titulo: "Campeao",
    desc: "Vencer 10 desafios",
    icone: "*",
    meta: 10,
    tipo: "desafios_vencidos",
  },
  {
    id: "v10",
    cat: "horas",
    titulo: "Video Lover",
    desc: "10 horas de videoaula",
    icone: "*",
    meta: 10,
    tipo: "videoaula_total",
  },
  {
    id: "v50",
    cat: "horas",
    titulo: "Video Viciado",
    desc: "50 horas de videoaula",
    icone: "*",
    meta: 50,
    tipo: "videoaula_total",
  },
  {
    id: "v100",
    cat: "horas",
    titulo: "Video Mestre",
    desc: "100 horas de videoaula",
    icone: "*",
    meta: 100,
    tipo: "videoaula_total",
  },
];
